import {AbstractView} from "../../../views/AbstractView";
import {
  INotificationListController,
  IT_NOTIFICATION_LIST_CONTROLLER, MK_NOTIFICATION_LIST
} from "../_controllers/INotificationListController";
import {Component} from "@angular/core";
import {StandardNotificationListController} from "../_controllers/standard-notification-list.controller";
import {NotificationListModel} from "../_models/NotificationListModel";
import {AlertInstance} from "../../../interfaces/domain/alert/AlertInstance";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'link-notification-list',
  templateUrl: './notification-list.view.html',
  styleUrls: ['./notification-list.view.scss'],
  providers: [
    { provide: IT_NOTIFICATION_LIST_CONTROLLER, useClass: StandardNotificationListController },
  ],
  animations: [
    trigger('fadeAnimation', [
      // :enter and :leave won't work here because :leave is executed when the overlay panel is toggled off.
      state('visible', style({opacity: 1})),
      state('notVisible', style({opacity: 0})),
      transition('visible => notVisible', [
        animate(400),
      ]),
    ]),
  ]
})
export class NotificationListView extends AbstractView<INotificationListController> {

  protected readonly model: NotificationListModel;

  protected lastRemovedAlertInstance: AlertInstance|null = null; // to help with animations.

  constructor() {
    super(IT_NOTIFICATION_LIST_CONTROLLER);

    this.model = this.getModel(MK_NOTIFICATION_LIST);
  }

  protected removeAlertInstance(alertInstance: AlertInstance): void {
    // Use timeout so fade animation can take place.
    this.lastRemovedAlertInstance = alertInstance;
    setTimeout(() => {
      this.handle('RemoveAlertInstance', {
        alertInstance: alertInstance,
      });

      this.lastRemovedAlertInstance = null;
    }, 500);
  }

  protected removeAll(): void {
    this.handle('RemoveAll');
  }
}
